import request from "@/CommonDP/utils/request";
import { isDef } from "@/CommonDP/utils/common";
import globalParams from '@/CommonDP/utils/globalParams.js';

// 日报
export default {
  // 我收到的-未读数量
  getUnreadNum(enterpriseId) {
    return request.get(`/prjWeekReport/getUnreadNum?enterpriseId=${enterpriseId}`);
  },
  // 获得筛选项目
  getPrjList(params) {
    return request.post("/prjWeekReport/getPrjList", params);
  },
  // 列表
  getList(params) {
    return request.post("/prjWeekReport/list", params);
  },
  // 新增
  add(params) {
    return request.post("/prjWeekReport/add", params);
  },
  // 详情
  getReportDetails(reportId) {
    return request.get(`/prjWeekReport/getReportDetails?reportId=${reportId}`);
  },
  // 撤回
  recall(reportId) {
    return request.get(`/prjWeekReport/recall?reportId=${reportId}`);
  },
  // 删除
  delete(reportId) {
    return request.get(`/prjWeekReport/delete?reportId=${reportId}`);
  },
  // 修改
  update(params) {
    return request.post("/prjWeekReport/update", params);
  },
  // 项目列表
  getProjects(enterpriseId) {
    return request.get(`/project/getProjectsByUserId?enterpriseId=${enterpriseId}`);
  },
  // 添加评论
  addComment(params) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/comment/add");
    if (isDef(newUrl)) {
      return request.post(`${newUrl}`, params);
    }
    return request.post("/comment/add", params);
  },
  // 根据关联id查询评论
  getCommentList(params) {
    return request.get("/comment/list", { params: params });
  }
};
